__turbopack_context__.v({
  "image": "index-module__GP5rqW__image",
  "surf": "index-module__GP5rqW__surf",
  "turtle": "index-module__GP5rqW__turtle",
});
